import React from 'react';

interface SVGLocationPinIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const SVGLocationPinIcon: React.FC<SVGLocationPinIconProps> = ({
  className,
  color = '#525257',
  size = 16,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    {/* No clipPath: its fixed id repeats on every pin on the page, and a stale or hidden first copy
        can blank out the others (the clip was the full 16×16 box anyway). */}
    <path
      d="M7.99935 12.4444C8.08028 12.4445 8.1588 12.4169 8.22192 12.3662C8.43099 12.1977 13.3327 8.21973 13.3327 5.33333C13.3327 3.91884 12.7708 2.56229 11.7706 1.5621C10.7704 0.561903 9.41383 0 7.99935 0C6.58486 0 5.22831 0.561903 4.22811 1.5621C3.22792 2.56229 2.66602 3.91884 2.66602 5.33333C2.66602 8.21973 7.5677 12.1977 7.77677 12.3662C7.8399 12.4169 7.91841 12.4445 7.99935 12.4444ZM7.99935 3.2C8.35096 3.2 8.69467 3.30426 8.98703 3.49961C9.27938 3.69495 9.50724 3.9726 9.6418 4.29745C9.77635 4.62229 9.81156 4.97975 9.74296 5.3246C9.67437 5.66946 9.50505 5.98623 9.25642 6.23485C9.0078 6.48348 8.69103 6.6528 8.34617 6.72139C8.00132 6.78999 7.64387 6.75478 7.31902 6.62023C6.99417 6.48567 6.71652 6.25781 6.52118 5.96545C6.32583 5.6731 6.22157 5.32939 6.22157 4.97777C6.22157 4.50628 6.40887 4.05409 6.74227 3.7207C7.07567 3.3873 7.52785 3.2 7.99935 3.2Z"
      fill={color}
    />
    <path
      d="M1.66602 15C1.66602 15.2652 1.77137 15.5196 1.95891 15.7071C2.14645 15.8946 2.4008 16 2.66602 16H13.3327C13.5979 16 13.8523 15.8946 14.0398 15.7071C14.2273 15.5196 14.3327 15.2652 14.3327 15C14.3327 14.7348 14.2273 14.4804 14.0398 14.2929C13.8523 14.1054 13.5979 14 13.3327 14H2.66602C2.4008 14 2.14645 14.1054 1.95891 14.2929C1.77137 14.4804 1.66602 14.7348 1.66602 15Z"
      fill={color}
    />
  </svg>
);

export default SVGLocationPinIcon;
